export default __webpack_public_path__ + "static/media/google_firebase_icon-icons.com_61474.d7d5280a.png";